<template>
  <div>
    <input
      type="text"
      v-model="searchQuery"
      class="search-box"
      placeholder="输入姓名或护照号进行查询"
    />
    <ul class="image-list" id="image-list">
      <li v-for="image in filteredImages" :key="image.name">
        <img :src="image.src" :alt="image.name" loading="lazy" />
        <span>{{ image.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { Image } from "@/config/types";

export default defineComponent({
  props: {
    images: {
      type: Array as () => Image[],
      required: true,
    },
  },
  setup(props) {
    const searchQuery = ref("");
    const filteredImages = ref<Image[]>([]);

    // 添加防抖函数
    const debounce = (fn: Function, delay: number) => {
      let timer: number;
      return (...args: any[]) => {
        clearTimeout(timer);
        timer = (setTimeout(() => fn.apply(this, args), delay) as unknown) as number;
      };
    };

    const filterImages = () => {
      if (!searchQuery.value) {
        filteredImages.value = [];
        return;
      }
      filteredImages.value = props.images.filter((image: Image) =>
        image.name.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    };

    // 使用防抖后的filterImages
    watch(searchQuery, debounce(filterImages, 500));

    return {
      searchQuery,
      filteredImages,
    };
  },
});
</script>
